/*###########################################################################
// Barba
//#########################################################################*/

import { gsap } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"
import Lenis from 'lenis';
import barba from '@barba/core';
import { scrollTo } from './utilities/_scrollTo'

const pageTransition = document.querySelector('.pageTransition')
const pageTransitionPanels = pageTransition.querySelectorAll('.pageTransition__panel')

const tlPageTransition = gsap.timeline({
	paused: true,
	onComplete: function(timeline) {
		tlPageTransition.restart()
		tlPageTransition.pause()
	}
})

for (let i = 0; i < pageTransitionPanels.length; i++) {
	const panel = pageTransitionPanels[i]

	if (i == 0) {
		tlPageTransition.to(panel, {
			duration: 0.8,
			ease: "power1.out",
			y: 0
		})
	} else {
		tlPageTransition.to(panel, {
			duration: 0.8,
			ease: "power1.out",
			y: 0
		}, ">-" + (0.75 - ((i / 100) * 5)))
	}

	tlPageTransition.to(panel, {
		duration: 0.8,
		ease: "power1.out",
		y: -window.innerHeight,
	}, ">-" + (0.75 - ((i / 100) * 5)))
}

// Header transition buttons
//

const headerButtons = document.querySelectorAll('.header__button')

const resetHeaderButtons = () => {
	for (let i = 0; i < headerButtons.length; i++) {
		const headerButton = headerButtons[i]

		headerButton.classList.add('header__button--hide')
	}
}

const setHeaderButtons = (currentPath) => {
	resetHeaderButtons()

	const headerButtonsMain = document.querySelectorAll('.header__button--main')
	const headerButtonsToSet = document.querySelectorAll('.header__button[data-path="' + currentPath + '"]')

	if (headerButtonsToSet.length) {
		for (let i = 0; i < headerButtonsToSet.length; i++) {
			const headerButton = headerButtonsToSet[i]

			headerButton.classList.remove('header__button--hide')
		}
	} else {
		for (let i = 0; i < headerButtonsMain.length; i++) {
			const headerButton = headerButtonsMain[i]

			headerButton.classList.remove('header__button--hide')
		}
	}
}

// Init lenis
//
window.lenis = new Lenis({
	syncTouch: true,
})

// Keep ScrollTrigger in the same frame as Lenis
//
window.lenis.on('scroll', ScrollTrigger.update)

gsap.ticker.add((time) => {
	window.lenis.raf(time * 1000)
})

gsap.ticker.lagSmoothing(0)

// Prevent scroll position history
//
window.history.scrollRestoration = "manual"

barba.init({
	transitions: [{
		sync: true,
		name: 'opacity-transition',
		beforeLeave(data) {
			tlPageTransition.play()

			const beforeEnterEvent = new CustomEvent('before-page-change')
			window.dispatchEvent(beforeEnterEvent)

			// Handle header button updates
			//
			setTimeout(function() {
				setHeaderButtons(data.next.url.path)
			}, 500)
		},
		before(data) {
			if (data.trigger === 'back' || data.trigger === 'forward' || data.trigger === 'popstate') {
				window.location.reload()
			}
		},
		enter(data) {
			if (window.lenis !== undefined) {
				window.lenis.stop()
			}

			setTimeout(function() {
				window.scrollTo(0, 0)
			}, 500)

			setTimeout(function() {
				if (window.lenis !== undefined) {
					window.lenis.start()
				}
			}, 1000)
		},
		after(data) {
			const enterEvent = new CustomEvent('page-change')
			window.dispatchEvent(enterEvent)
		},
		afterEnter({ trigger }) {
			setTimeout(function() {
				if (trigger && trigger.hash) {
					const target = document.querySelector(trigger.hash)

					if (target !== null) {
						const offsetAmount = document.querySelector('.header').clientHeight + (window.innerWidth < 1024 ? 140 : 80)
						scrollTo(target, -offsetAmount)
					}
				}
			}, 1500)
		}
	}],
	preventRunning: true,
	timeout: 7500,
	prevent: ({ href }) => {
    // Prevent if the link's href matches the current page URL
		if (href === window.location.href) {
			return true
		} else if (href.indexOf('retailer-area') !== -1) {
			return true
		} else if (window.location.href.indexOf('retailer-area') !== -1) {
			return true
		} else if (window.location.href.indexOf('find-a-retailer') !== -1) {
			return true
		} else if (href.indexOf('find-a-retailer') !== -1) {
			return true
		} else if (window.location.href.indexOf('kitchen-visualiser') !== -1) {
			return true
		} else if (href.indexOf('kitchen-visualiser') !== -1) {
			return true
		}
  }
})

barba.hooks.leave(() => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, 250)
  })
})

barba.hooks.beforeEnter(({ next }) => {
	setTimeout(() => {
		if (typeof htmx !== 'undefined') {
			htmx.process(next.container)
		}
	}, 250)
})

window.addEventListener('load', function() {
	setTimeout(function() {
		ScrollTrigger.sort()
		ScrollTrigger.refresh()
	}, 500)
})

window.addEventListener('page-change', function() {
	setTimeout(function() {
		ScrollTrigger.sort()
		ScrollTrigger.refresh()
	}, 500)
})

